/* HO3 Relaunch-Entwurf: Einblenden beim Scrollen, Zahlen hochzählen, Karussell, Warenkorb, Scroll-Zustand.
   API für Sections:
   - data-ho3-reveal            Element blendet beim Scrollen ein
   - data-ho3-reveal="stagger"  Kinder blenden nacheinander ein
   - data-ho3-reveal="bild"     Bildrahmen öffnet sich weich
   - data-ho3-count             Zahl zählt beim Erscheinen hoch (Inhalt z. B. "99,6" oder "20.000")
   - data-ho3-karussell         Wrapper; darin [data-ho3-spur] (Scroller) und Knöpfe [data-ho3-zurueck] / [data-ho3-weiter];
                                optional data-ho3-autoplay="6000" (läuft selbst weiter, pausiert bei Interaktion)
   - form[data-ho3-kauf]        Formular mit input name="id"; legt per Ajax in den Warenkorb und öffnet den Drawer
   - data-ho3-durchlauf         Scroll-Durchlauf: Section bleibt stehen, Kartenreihe wandert seitlich (Aufbau siehe unten)
   - a[data-ho3-lupe]           öffnet ein Bild groß in einer Vorschau-Ebene (Dialog, Escape, Fokus zurück)
   - [data-ho3-chat]            öffnet den Live-Chat (Richpanel); [data-ho3-chat-karte] verschwindet ohne Chat
   - html.ho3-gescrollt         gesetzt, sobald die Seite mehr als 8px gescrollt ist
   - html.ho3-weit              gesetzt ab 120px (Startseite mobil: Chat-Knopf erst, wenn der Kauf-Button aus seinem Bereich ist) */
(function () {
  'use strict';
  var html = document.documentElement;
  var reduziert = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  var bewegung = !reduziert && !editor && 'IntersectionObserver' in window;
  if (bewegung) html.classList.add('ho3-motion');

  /* Zahlen im deutschen Format lesen und schreiben */
  function lies(text) {
    var t = String(text).trim().replace(/\./g, '').replace(',', '.');
    var n = parseFloat(t);
    var dez = (String(text).split(',')[1] || '').replace(/\D/g, '').length;
    return { wert: isNaN(n) ? null : n, dez: dez, tausender: /\d\.\d{3}/.test(String(text)) };
  }
  function schreib(n, dez, tausender) {
    var s = n.toFixed(dez).replace('.', ',');
    if (tausender) {
      var teile = s.split(',');
      teile[0] = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      s = teile.join(',');
    }
    return s;
  }
  function vorbereitenZaehler(el) {
    if (el.hasAttribute('data-ho3-count-bereit')) return;
    var z = lies(el.textContent);
    if (z.wert === null) return;
    el.setAttribute('data-ho3-count-bereit', '');
    el.setAttribute('data-ho3-ziel', el.textContent.trim());
    if (bewegung) el.textContent = schreib(0, z.dez, z.tausender);
  }
  function zaehlen(el) {
    var ziel = el.getAttribute('data-ho3-ziel');
    if (!ziel || el.hasAttribute('data-ho3-gezaehlt')) return;
    el.setAttribute('data-ho3-gezaehlt', '');
    var z = lies(ziel);
    if (!bewegung || z.wert === null) { el.textContent = ziel; return; }
    var start = null, dauer = 1400;
    function schritt(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dauer);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = p < 1 ? schreib(z.wert * e, z.dez, z.tausender) : ziel;
      if (p < 1) requestAnimationFrame(schritt);
    }
    requestAnimationFrame(schritt);
  }

  function zeige(el) {
    el.classList.add('is-sichtbar');
    if (el.hasAttribute('data-ho3-count')) zaehlen(el);
    Array.prototype.forEach.call(el.querySelectorAll('[data-ho3-count]'), zaehlen);
  }
  var beobachter = bewegung ? new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) {
      if (e.isIntersecting) { zeige(e.target); beobachter.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  /* Karussell: blättert um eine Kartenbreite, Knöpfe an den Enden gesperrt */
  function karussell(root) {
    if (root.hasAttribute('data-ho3-karussell-bereit')) return;
    root.setAttribute('data-ho3-karussell-bereit', '');
    var spur = root.querySelector('[data-ho3-spur]');
    if (!spur) return;
    /* Mehrere Knopf-Paare erlaubt (z. B. Desktop oben neben der Überschrift, mobil unter den Karten) */
    var zurueck = root.querySelectorAll('[data-ho3-zurueck]');
    var weiter = root.querySelectorAll('[data-ho3-weiter]');
    var balken = root.querySelector('[data-ho3-karussell-balken]');
    function schrittweite() {
      var k = spur.children[0];
      if (!k) return spur.clientWidth;
      var gap = parseFloat(getComputedStyle(spur).columnGap || getComputedStyle(spur).gap) || 0;
      return k.getBoundingClientRect().width + gap;
    }
    function status() {
      var max = spur.scrollWidth - spur.clientWidth - 2;
      Array.prototype.forEach.call(zurueck, function (b) { b.disabled = spur.scrollLeft <= 2; });
      Array.prototype.forEach.call(weiter, function (b) { b.disabled = spur.scrollLeft >= max; });
      root.classList.toggle('ho3-karussell--statisch', max <= 0);
      if (balken) {
        var sicht = spur.scrollWidth > 0 ? spur.clientWidth / spur.scrollWidth : 1;
        var p = max > 0 ? Math.min(1, Math.max(0, spur.scrollLeft / max)) : 1;
        balken.style.transform = 'scaleX(' + Math.min(1, sicht + (1 - sicht) * p).toFixed(4) + ')';
      }
    }
    Array.prototype.forEach.call(zurueck, function (b) { b.addEventListener('click', function () { spur.scrollBy({ left: -schrittweite(), behavior: reduziert ? 'auto' : 'smooth' }); }); });
    Array.prototype.forEach.call(weiter, function (b) { b.addEventListener('click', function () { spur.scrollBy({ left: schrittweite(), behavior: reduziert ? 'auto' : 'smooth' }); }); });
    spur.addEventListener('scroll', function () { window.requestAnimationFrame(status); }, { passive: true });
    window.addEventListener('resize', status);
    status();

    /* Optional mit der Maus ziehen (data-ho3-ziehen an der Wurzel): nur Maus, Touch und Trackpad wischen nativ.
       Nach einem Zug wird der folgende Klick verschluckt, damit Karten-Links nicht versehentlich öffnen. */
    if (root.hasAttribute('data-ho3-ziehen') && window.PointerEvent) {
      var zug = null, verschlucken = false;
      spur.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        zug = { x: e.clientX, links: spur.scrollLeft, aktiv: false, id: e.pointerId };
      });
      spur.addEventListener('pointermove', function (e) {
        if (!zug || e.pointerId !== zug.id) return;
        var dx = e.clientX - zug.x;
        if (!zug.aktiv) {
          if (Math.abs(dx) < 6) return;
          zug.aktiv = true;
          spur.classList.add('is-gezogen');
          try { spur.setPointerCapture(zug.id); } catch (err) {}
        }
        spur.scrollLeft = zug.links - dx;
      });
      function zugEnde() {
        if (!zug) return;
        if (zug.aktiv) {
          verschlucken = true;
          setTimeout(function () { verschlucken = false; }, 60);
          var rest = spur.scrollLeft;
          spur.classList.remove('is-gezogen');
          /* Nach dem Loslassen zur nächsten Karte einrasten (Snap greift wieder) */
          spur.scrollTo({ left: rest, behavior: 'auto' });
        }
        zug = null;
      }
      spur.addEventListener('pointerup', zugEnde);
      spur.addEventListener('pointercancel', zugEnde);
      spur.addEventListener('click', function (e) { if (verschlucken) { e.preventDefault(); e.stopPropagation(); } }, true);
      spur.addEventListener('dragstart', function (e) { if (zug) e.preventDefault(); });
    }

    /* Optional selbst weiterlaufen: data-ho3-autoplay="6000" (ms). Pause bei Maus, Fokus, Berührung und Klick,
       weiter 6 s nach der letzten Interaktion, am Ende weich zurück zum Anfang. Nie bei reduzierter Bewegung oder im Editor. */
    var takt = parseInt(root.getAttribute('data-ho3-autoplay'), 10);
    if (takt > 0 && bewegung) {
      var pause = false, zuletzt = 0, sichtbar = false;
      function stopp() { pause = true; zuletzt = Date.now(); }
      ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (n) { root.addEventListener(n, stopp, { passive: true }); });
      root.addEventListener('mouseleave', function () { pause = false; zuletzt = Date.now(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { sichtbar = e[0].isIntersecting && e[0].intersectionRatio >= 0.25; }, { threshold: [0, 0.25, 0.5] }).observe(root);
      }
      setInterval(function () {
        if (!sichtbar || document.hidden) return;
        if (pause && Date.now() - zuletzt < 6000) return;
        pause = false;
        var max = spur.scrollWidth - spur.clientWidth - 2;
        if (max <= 0) return;
        if (spur.scrollLeft >= max) spur.scrollTo({ left: 0, behavior: 'smooth' });
        else spur.scrollBy({ left: schrittweite(), behavior: 'smooth' });
      }, takt);
    }
  }

  /* Warenkorb: Ajax wie die Buybox des Themes, danach Drawer öffnen */
  function kaufen(form) {
    if (form.hasAttribute('data-ho3-kauf-bereit')) return;
    form.setAttribute('data-ho3-kauf-bereit', '');
    form.addEventListener('submit', function (ev) {
      if (!window.fetch) return;
      ev.preventDefault();
      var knopf = form.querySelector('[type="submit"]');
      var id = form.querySelector('[name="id"]');
      var menge = form.querySelector('[name="quantity"]');
      if (!id || !id.value) { form.submit(); return; }
      if (knopf) knopf.classList.add('is-laedt');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id.value), quantity: menge ? Number(menge.value) || 1 : 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      }).then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, detail: { openDrawer: true } }));
        setTimeout(function () {
          if (!document.querySelector('.cart-drawer-modal.cc-popup--visible, .cart-drawer-modal.cc-popup--open')) {
            document.documentElement.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true }));
          }
        }, 1200);
      }).catch(function () {
        window.location.href = '/cart';
      }).finally(function () {
        if (knopf) knopf.classList.remove('is-laedt');
      });
    });
  }

  /* Scroll-Durchlauf: die Section bleibt beim Scrollen stehen (position: sticky), die Kartenreihe wandert seitlich,
     ein Balken zeigt den Fortschritt. Aufbau:
       [data-ho3-durchlauf="0.85"]            Wurzel; Zahl = Scrollstrecke je Pixel Seitwärtsweg (optional)
         [data-ho3-durchlauf-buehne]          bekommt die Höhe: Fensterhöhe unter dem Header plus Scrollstrecke
           [data-ho3-durchlauf-sticky]        Bühne, die stehen bleibt (Überschrift, Karten, Fortschritt); das Skript setzt
                                              --ho3-dl-oben (Header plus 16px) und --ho3-dl-hoehe (Rest des Fensters)
             [data-ho3-spur]                  Kartenreihe (wird per transform verschoben)
             [data-ho3-durchlauf-balken]      optional, wird per scaleX gefüllt
             [data-ho3-durchlauf-zaehler]     optional, „4 von 17“
     Zustand in data-ho3-durchlauf-zustand: an (angeheftet), passt (Reihe passt ohne Durchlauf),
     wischen (schmal oder zu wenig Höhe: seitlich wischen), raster (reduzierte Bewegung oder Theme-Editor), mess (kurz beim Messen).
     Passt die Bühne nur ohne Verzichtbares ins Fenster, setzt das Skript data-ho3-durchlauf-knapp an die Wurzel
     (die Section blendet dann z. B. ihre Einleitung aus). */
  var durchlaeufe = [];
  function durchlauf(root) {
    if (root.hasAttribute('data-ho3-durchlauf-bereit')) return;
    root.setAttribute('data-ho3-durchlauf-bereit', '');
    var buehne = root.querySelector('[data-ho3-durchlauf-buehne]');
    var sticky = root.querySelector('[data-ho3-durchlauf-sticky]');
    var spur = root.querySelector('[data-ho3-spur]');
    if (!buehne || !sticky || !spur) return;
    var balken = root.querySelector('[data-ho3-durchlauf-balken]');
    var zaehler = root.querySelector('[data-ho3-durchlauf-zaehler]');
    var breit = window.matchMedia ? window.matchMedia('(min-width: 768px)') : { matches: true };
    var faktor = parseFloat(root.getAttribute('data-ho3-durchlauf')) || 0.85;
    var d = { root: root, aktiv: false, max: 0, strecke: 0, oben: 0, links: 0, n: -1 };

    function zustand(z) { root.setAttribute('data-ho3-durchlauf-zustand', z); }
    function kopfhoehe() {
      var k = document.querySelector('.section-header');
      if (!k) return 0;
      var pos = getComputedStyle(k).position;
      return pos === 'sticky' || pos === 'fixed' ? Math.max(0, Math.round(k.getBoundingClientRect().height)) : 0;
    }
    function fortschritt() {
      var r = buehne.getBoundingClientRect();
      var p = d.strecke > 0 ? (d.oben - r.top) / d.strecke : 0;
      return p < 0 ? 0 : (p > 1 ? 1 : p);
    }
    function malen() {
      if (!d.aktiv) return;
      var p = fortschritt();
      var x = p * d.max;
      spur.style.transform = 'translate3d(' + (-x).toFixed(1) + 'px,0,0)';
      if (balken) balken.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      if (zaehler) {
        var kante = x + sticky.clientWidth - d.links * 0.5, n = 0;
        for (var i = 0; i < spur.children.length; i++) {
          var k = spur.children[i];
          if (k.offsetLeft + k.offsetWidth * 0.6 <= kante) n = i + 1;
        }
        if (n !== d.n) { d.n = n; zaehler.textContent = n + ' von ' + spur.children.length; }
      }
    }
    function messen() {
      d.aktiv = false;
      buehne.style.height = '';
      spur.style.transform = '';
      root.removeAttribute('data-ho3-durchlauf-knapp');
      if (balken) balken.style.transform = '';
      if (reduziert || editor) { zustand('raster'); return; }
      if (!breit.matches) { zustand('wischen'); return; }
      zustand('mess');
      var fenster = sticky.clientWidth;
      d.links = parseFloat(getComputedStyle(spur).paddingLeft) || 0;
      d.max = Math.max(0, Math.ceil(spur.getBoundingClientRect().width - fenster));
      var erste = spur.children[0];
      var kartenbreite = erste ? erste.getBoundingClientRect().width : 300;
      if (d.max <= kartenbreite * 0.6) { zustand('passt'); return; }
      /* Bühne direkt unter dem Header (16px Abstand), so hoch wie der Rest des Fensters; der Inhalt steht darin mittig.
         Reicht die Höhe nicht, entfällt zuerst das Verzichtbare (data-ho3-durchlauf-knapp, z. B. die Einleitung),
         reicht sie dann immer noch nicht: seitlich wischen. */
      var luft = 32;
      d.oben = kopfhoehe() + 16;
      var frei = window.innerHeight - d.oben;
      if (sticky.offsetHeight > frei - luft) {
        root.setAttribute('data-ho3-durchlauf-knapp', '');
        if (sticky.offsetHeight > frei - luft) { root.removeAttribute('data-ho3-durchlauf-knapp'); zustand('wischen'); return; }
      }
      d.strecke = Math.round(d.max * faktor);
      root.style.setProperty('--ho3-dl-oben', d.oben + 'px');
      root.style.setProperty('--ho3-dl-hoehe', frei + 'px');
      buehne.style.height = (frei + d.strecke) + 'px';
      zustand('an');
      d.aktiv = true;
      d.n = -1;
      malen();
    }
    function nachMessen() {
      messen();
      /* Karussell-Knöpfe an den neuen Zustand anpassen */
      try { spur.dispatchEvent(new Event('scroll')); } catch (e) {}
    }
    /* Tastatur: fokussierte Karte in den sichtbaren Bereich holen */
    spur.addEventListener('focusin', function (e) {
      if (!d.aktiv || !d.max) return;
      var karte = e.target;
      while (karte && karte.parentNode !== spur) karte = karte.parentNode;
      if (!karte) return;
      var x = fortschritt() * d.max;
      var sichtbar = karte.offsetLeft >= x + d.links - 2 && karte.offsetLeft + karte.offsetWidth <= x + sticky.clientWidth - d.links + 2;
      if (sichtbar) return;
      var ziel = Math.min(d.max, Math.max(0, karte.offsetLeft - d.links));
      var r = buehne.getBoundingClientRect();
      window.scrollBy(0, r.top - (d.oben - (ziel / d.max) * d.strecke));
    });
    d.messen = nachMessen;
    d.malen = malen;
    durchlaeufe.push(d);
    if (breit.addEventListener) breit.addEventListener('change', nachMessen);
    nachMessen();
  }
  var dlWartet = false, dlTimer = null;
  window.addEventListener('scroll', function () {
    if (dlWartet || !durchlaeufe.length) return;
    dlWartet = true;
    requestAnimationFrame(function () { dlWartet = false; durchlaeufe.forEach(function (d) { d.malen(); }); });
  }, { passive: true });
  function alleNeuMessen() {
    durchlaeufe = durchlaeufe.filter(function (d) { return document.documentElement.contains(d.root); });
    durchlaeufe.forEach(function (d) { d.messen(); });
  }
  window.addEventListener('resize', function () { clearTimeout(dlTimer); dlTimer = setTimeout(alleNeuMessen, 150); });
  window.addEventListener('load', alleNeuMessen);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(alleNeuMessen);

  /* Vorschau-Ebene (Lupe): <a data-ho3-lupe="große-bild-url" href="…"> öffnet das Bild groß in einem Dialog.
     Optional data-ho3-lupe-alt und data-ho3-lupe-text. Escape, Schließen-Knopf und Klick daneben schließen,
     der Fokus kehrt zum Auslöser zurück. Ohne Dialog-Unterstützung folgt der Link normal. */
  var lupe = null;
  function lupeBauen() {
    if (lupe) return lupe;
    var dlg = document.createElement('dialog');
    if (typeof dlg.showModal !== 'function') return null;
    dlg.className = 'ho3 ho3-lupe';
    dlg.setAttribute('aria-label', 'Vorschau');
    dlg.innerHTML = '<figure class="ho3-lupe__rahmen"><img class="ho3-lupe__bild" alt=""><figcaption class="ho3-lupe__text"></figcaption></figure>' +
      '<button type="button" class="ho3-lupe__zu" aria-label="Vorschau schließen"><svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 5l10 10M15 5L5 15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.querySelector('.ho3-lupe__zu').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('close', function () {
      html.classList.remove('ho3-lupe-offen');
      var a = dlg._ausloeser;
      dlg._ausloeser = null;
      if (a && a.focus) { try { a.focus({ preventScroll: true }); } catch (e) { a.focus(); } }
    });
    lupe = dlg;
    return dlg;
  }
  /* Escape schließt die Vorschau selbst: die Cookie-App (Pandectes) ruft bei jedem Escape auf document preventDefault auf,
     dadurch unterbleibt das eingebaute Schließen des Dialogs. Die Capture-Phase auf window läuft vor deren Listener;
     der close-Handler oben räumt die html-Klasse weg und gibt den Fokus zurück. */
  window.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && lupe && lupe.open) lupe.close();
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-ho3-lupe]') : null;
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var dlg = lupeBauen();
    if (!dlg) return;
    e.preventDefault();
    var bild = dlg.querySelector('.ho3-lupe__bild');
    var gross = a.getAttribute('data-ho3-lupe') || a.href;
    /* Sofort das schon geladene Vorschaubild zeigen (kein leerer Rahmen), dann gegen die große Fassung tauschen */
    var vorschau = a.querySelector('img');
    var sofort = vorschau && vorschau.complete && vorschau.naturalWidth ? (vorschau.currentSrc || vorschau.src) : '';
    bild.removeAttribute('src');
    bild.removeAttribute('srcset');
    bild.src = sofort || gross;
    if (sofort && sofort !== gross) {
      var laden = new Image();
      laden.onload = function () { if (dlg.open && dlg._ausloeser === a) bild.src = gross; };
      laden.src = gross;
    }
    bild.alt = a.getAttribute('data-ho3-lupe-alt') || '';
    dlg.querySelector('.ho3-lupe__text').textContent = a.getAttribute('data-ho3-lupe-text') || '';
    dlg._ausloeser = a;
    html.classList.add('ho3-lupe-offen');
    dlg.showModal();
    dlg.querySelector('.ho3-lupe__zu').focus();
  });

  /* Live-Chat (Richpanel) öffnen: <a href="#rp-customer-widget-help_and_support" data-ho3-chat>.
     Der Richpanel-Messenger öffnet sich über diesen Anker; ein zweiter Klick setzt den Anker neu.
     Ist nach dem Laden kein Richpanel da, verschwinden Elemente mit data-ho3-chat-karte (keine tote Chat-Karte). */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-ho3-chat]') : null;
    if (!a) return;
    var ziel = a.getAttribute('data-ho3-chat') || '#rp-customer-widget-help_and_support';
    e.preventDefault();
    if (window.location.hash === ziel && window.history && history.replaceState) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    window.location.hash = ziel;
  });
  /* 1.10.: Richpanel kommt oft erst Sekunden nach dem load-Event; bis zu 15 s warten, bevor die Chat-Karte verschwindet */
  window.addEventListener('load', function () {
    var versuche = 0;
    (function pruefen() {
      if (window.Richpanel || window.richpanel) return;
      if (++versuche < 30) { setTimeout(pruefen, 500); return; }
      Array.prototype.forEach.call(document.querySelectorAll('[data-ho3-chat-karte]'), function (el) { el.hidden = true; });
    })();
  });

  /* 1.10.: Ankündigungsleiste mit Link: Klick irgendwo auf die farbige Fläche folgt dem Link der gerade sichtbaren Meldung.
     Pfeile, Länder- und Sprachauswahl und echte Links behalten ihre eigene Funktion. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var leiste = t.closest('.section-announcement-bar .announcement-bar');
    if (!leiste || t.closest('a, button, select, input, .header-disclosures, .disclosure, .social-links')) return;
    var link = leiste.querySelector('.announcement:not(.announcement--inactive) a.ho3-leiste-link');
    if (link) link.click();
  });

  function init(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-ho3-count]'), vorbereitenZaehler);
    Array.prototype.forEach.call(root.querySelectorAll('[data-ho3-reveal]:not([data-ho3-init])'), function (el) {
      el.setAttribute('data-ho3-init', '');
      if (el.getAttribute('data-ho3-reveal') === 'stagger') {
        Array.prototype.forEach.call(el.children, function (k, i) { k.style.setProperty('--ho3-i', Math.min(i, 8)); });
      }
      if (beobachter) beobachter.observe(el); else zeige(el);
    });
    /* Zähler außerhalb eines Reveal-Elements eigenständig beobachten */
    Array.prototype.forEach.call(root.querySelectorAll('[data-ho3-count]:not([data-ho3-init])'), function (el) {
      if (el.closest('[data-ho3-reveal]')) return;
      el.setAttribute('data-ho3-init', '');
      if (beobachter) beobachter.observe(el); else zaehlen(el);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-ho3-karussell]'), karussell);
    Array.prototype.forEach.call(root.querySelectorAll('[data-ho3-durchlauf]'), durchlauf);
    Array.prototype.forEach.call(root.querySelectorAll('form[data-ho3-kauf]'), kaufen);
  }

  /* Scroll-Zustand für Header und schwebende Elemente */
  var wartet = false;
  function scrollZustand() { html.classList.toggle('ho3-gescrollt', window.scrollY > 8); html.classList.toggle('ho3-weit', window.scrollY > 120); wartet = false; }
  window.addEventListener('scroll', function () { if (!wartet) { wartet = true; requestAnimationFrame(scrollZustand); } }, { passive: true });
  scrollZustand();

  /* 1.10.: Delm-Lieferhinweis im Shadow DOM: „Wenige Einheiten“ in Orange, Countdown im Shop-Grün */
  function delmFarben() {
    if (!window.customElements || typeof CSSStyleSheet === 'undefined') return;
    var blatt;
    try {
      blatt = new CSSStyleSheet();
      blatt.replaceSync('.delm-widget{text-wrap:balance}.delm-widget strong{font-weight:600;color:#111}.delm-widget .delm-widget-title,.delm-widget .delm-widget-title strong{color:#C2570C}.delm-widget span.countdown{color:#1E7A4C;font-weight:600}');
    } catch (e) { return; }
    function faerben() {
      Array.prototype.forEach.call(document.querySelectorAll('delm-widget'), function (w) {
        var r = w.shadowRoot;
        if (r && r.adoptedStyleSheets && r.adoptedStyleSheets.indexOf(blatt) < 0) r.adoptedStyleSheets = r.adoptedStyleSheets.concat(blatt);
      });
    }
    customElements.whenDefined('delm-widget').then(function () { faerben(); setTimeout(faerben, 800); setTimeout(faerben, 2500); });
  }
  delmFarben();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  window.HO3 = window.HO3 || {};
  window.HO3.init = init;
})();
